module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuODY3IiBoZWlnaHQ9IjUzNy4xNTIiIHZpZXdCb3g9IjAgMCA0NzAuODY3IDUzNy4xNTIiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzU5NyIgZGF0YS1uYW1lPSLjg5HjgrkgMzU5NyIgZD0iTTUxNy4yMzIsMTQwNi42OVYxMDQ4TDk4OC4xLDg2OS41MzZ2MzU4LjY4OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MTcuMjMxIC04NjkuNTM3KSIgZmlsbD0ibGltZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_470.svg
// module id = tMW5
// module chunks = 0